// The values of the Postgres enums of identity that travel in the contracts (ADR-271): plain tuples, without zod, so
// that @nexxt/db builds its enums without evaluating any schema. The barrel of the domain re-exports them.

/** What a single-use token is for (`party.auth_token`); invitations have their own table. */
export const authTokenPurposes = ["email_verification", "password_reset", "email_change"] as const;
export type AuthTokenPurpose = (typeof authTokenPurposes)[number];

/** What became of a request (`party.mfa_reset_request`): one waits at a time for a user. */
export const mfaResetStatuses = ["pending", "approved", "rejected"] as const;
export type MfaResetStatus = (typeof mfaResetStatuses)[number];

/** Kinds of client: a Client ID Metadata Document (its URL is the id), or one registered with DCR (RFC 7591). */
export const oauthClientKinds = ["metadata_document", "registered"] as const;
export type OAuthClientKind = (typeof oauthClientKinds)[number];

/** Kinds of the secrets of a connection, each kept as an HMAC (ADR-262 point 3). */
export const oauthTokenKinds = ["code", "access", "refresh"] as const;
export type OAuthTokenKind = (typeof oauthTokenKinds)[number];

/**
 * `pending` waits for the holder; `confirming` while Backstage runs it; then `confirmed`, `failed` (the domain refused
 * it, with its code) or `discarded`. A pending one past its end is `expired` in every answer; the table writes it only
 * when the same arguments are prepared again, which makes a new action (its end is never moved: ADR-265).
 */
export const preparedActionStatuses = ["pending", "confirming", "confirmed", "failed", "discarded", "expired"] as const;
export type PreparedActionStatus = (typeof preparedActionStatuses)[number];
